import { Loader } from "@aws-amplify/ui-react";

export const Spinner = ({ loading }: { loading: boolean }) => {
  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Loader
        size={"large"}
        emptyColor="lightgray"
        filledColor="rebeccapurple"
      />
    </div>
  );
};
